import React from "react"
import { createMarkup } from "@lib/functions"
import clsx from "clsx"

const DESCRIPTION =
  " <ul>\n" +
  "            <li>\n" +
  "              Mampu membuat desain interface dan user experience yang sederhana namun tetap sesuai\n" +
  "              dengan kebutuhan user baik Web dan mobile apps\n" +
  "            </li>\n" +
  "            <li>\n" +
  "              Mampu membuat desain interface dan user experience yang sederhana namun tetap sesuai\n" +
  "              dengan kebutuhan user baik Web dan mobile apps\n" +
  "            </li>\n" +
  "            <li>\n" +
  "              Mampu membuat desain interface dan user experience yang sederhana namun tetap sesuai\n" +
  "              dengan kebutuhan user baik Web dan mobile apps\n" +
  "            </li>\n" +
  "            <li>\n" +
  "              Mampu membuat desain interface dan user experience yang sederhana namun tetap sesuai\n" +
  "              dengan kebutuhan user baik Web dan mobile apps\n" +
  "            </li>\n" +
  "            <li>\n" +
  "              Mampu membuat desain interface dan user experience yang sederhana namun tetap sesuai\n" +
  "              dengan kebutuhan user baik Web dan mobile apps\n" +
  "            </li>\n" +
  "          </ul>"

interface DetailSectionProps {
  title: string
  description: string
}

const DetailSection: React.FC<DetailSectionProps> = ({ title, description }) => {
  return (
    <section>
      <div
        className={clsx(
          "bg-green text-center sm:text-md font-semibold sm:py-3 text-white rounded",
          "py-2.5"
        )}
      >
        {title}
      </div>

      <div className={clsx("sm:px-7 sm:py-8 bg-primary-grey rounded", "py-3 px-4")}>
        <div dangerouslySetInnerHTML={createMarkup(description)} className="markup" />
      </div>
    </section>
  )
}

interface DetailBodyProps {
  job_description: string
  job_requirement_position: string
  job_benefit: string
}

export function DetailBody({
  job_benefit,
  job_description,
  job_requirement_position,
}: DetailBodyProps) {
  return (
    <section className="flex flex-col gap-10 mb-20">
      <DetailSection title="Deskripsi Pekerjaan" description={job_description} />

      <DetailSection title="Persyaratan Posisi" description={job_requirement_position} />

      <DetailSection title="Benefit Posisi" description={job_benefit} />
    </section>
  )
}
